import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createRef, Component } from 'react';
import OtherClickListener from '../../../../../events/OtherClickListener';
import { stopPropagation } from '../../../../../helpers/common';
import { propFunc, propHistory, propShape, } from '../../../../../helpers/custom-prop-types';
import { isEnableSolutionChange, isEnableSolutionDelete, isEnableSolutionEdit, } from '../../../../../helpers/solution';
class OverViewMenu extends Component {
    constructor(props) {
        super(props);
        this.toggleMenu = (e) => {
            e.preventDefault();
            const { isShowMenu } = this.state;
            this.setState({
                isShowMenu: !isShowMenu,
            });
        };
        this.hideMenu = () => {
            this.setState({ isShowMenu: false });
        };
        this.showDestinationModal = (e) => {
            e.preventDefault();
            const { showModalChangeDestination } = this.props;
            showModalChangeDestination();
        };
        this.goToEdit = (e) => {
            e.preventDefault();
            const { history, solution } = this.props;
            if (solution.status === 1) {
                history.push(`/mypage/solutions/add/${solution.id}`);
            }
            else {
                history.push(`/mypage/solutions/edit/${solution.id}/`);
            }
        };
        this.showDeleteModal = (e) => {
            e.preventDefault();
            const { showModalDeleteSolution } = this.props;
            showModalDeleteSolution();
        };
        this.clickRef = createRef();
        this.clickListenerNo = null;
        this.state = {
            isShowMenu: false,
        };
    }
    componentDidMount() {
        this.clickListenerNo = OtherClickListener.setListener(this.clickRef.current, this.hideMenu);
    }
    componentWillUnmount() {
        OtherClickListener.deleteListener(this.clickListenerNo);
    }
    render() {
        const { isShowMenu } = this.state;
        const { profile, solution } = this.props;
        return (_jsxs("div", Object.assign({ className: 'overview-menu', onClick: stopPropagation, onKeyPress: stopPropagation, ref: this.clickRef, role: 'button', tabIndex: '-1' }, { children: [_jsx("button", Object.assign({ className: 'material-icons md-32 btn-drop', onClick: this.toggleMenu, type: 'button' }, { children: "more_vert" })), _jsxs("div", Object.assign({ className: `dropdown-menu ${isShowMenu ? 'is-visible' : ''}`, id: 'dropdown-menu' }, { children: [_jsxs("button", Object.assign({ className: 'link-text', disabled: !isEnableSolutionChange(solution, profile), onClick: this.showDestinationModal, type: 'button' }, { children: [_jsx("i", Object.assign({ className: 'material-icons md-18' }, { children: "location_on" })), "\u8ACB\u6C42\u5148\u5909\u66F4"] })), _jsxs("button", Object.assign({ className: 'link-text', disabled: !isEnableSolutionEdit(solution, profile), onClick: this.goToEdit, type: 'button' }, { children: [_jsx("i", Object.assign({ className: 'material-icons md-18' }, { children: "edit" })), "\u7DE8\u96C6"] })), _jsxs("button", Object.assign({ className: 'link-text', disabled: !isEnableSolutionDelete(solution, profile), onClick: this.showDeleteModal, type: 'button' }, { children: [_jsx("i", Object.assign({ className: 'material-icons md-18' }, { children: "delete" })), "\u524A\u9664"] }))] }))] })));
    }
}
OverViewMenu.propTypes = {
    history: propHistory(),
    profile: propShape().isRequired,
    showModalChangeDestination: propFunc().isRequired,
    showModalDeleteSolution: propFunc().isRequired,
    solution: propShape().isRequired,
};
export default OverViewMenu;
